import ContentUpdater from './ContentUpdater'

export default ContentUpdater
// eslint-disable-next-line import/export
export * from './ContentUpdater'
